<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getConfig } from "@/api/home";
import common from "@/utils/common";

export default {
  name: "App",
  created() {
    // 初始化数据
    this.getConfigData().then(data => {
      // 存储头像框
      this.$store.state.avatar_frames = data.avatar_frames;
    });
    this.$store.state.token = common.getUrlData("token");
    this.$store.state.topic_id = common.getUrlData("topic_id");
    console.log(this.$store.state, "this.$store.state");
  },
  methods: {
    // 获取初始化数据
    getConfigData() {
      return new Promise((resolve, reject) => {
        getConfig()
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
</script>

<style lang="scss">
#app {
  background-color: #fff;
}
</style>
